__turbopack_context__.v({
  "bg": "style-module-scss-module__88wvBa__bg",
  "container": "style-module-scss-module__88wvBa__container",
  "cta": "style-module-scss-module__88wvBa__cta",
  "ctaWrapper": "style-module-scss-module__88wvBa__ctaWrapper",
  "grid": "style-module-scss-module__88wvBa__grid",
  "modalBlock": "style-module-scss-module__88wvBa__modalBlock",
  "section": "style-module-scss-module__88wvBa__section",
  "step": "style-module-scss-module__88wvBa__step",
  "stepText": "style-module-scss-module__88wvBa__stepText",
  "steps": "style-module-scss-module__88wvBa__steps",
  "title": "style-module-scss-module__88wvBa__title",
  "video": "style-module-scss-module__88wvBa__video",
});
